module.exports = __webpack_public_path__ + "media/images/hiring_process-10d45ad729f8bafdffb8d33060d2db47.svg";